import {doc} from './docs.js';

doc(
    "hexToRGB",
    {
        "hexadecimal color string":""
    },
    "Returns rgb/rgba values in 3/4-part array for hexadecimal string"
);
export const hexToRGB = (object) => {
    return ([msg]) => {
        if (typeof msg !== "string" || msg[0] !== "#") {
            return;
        }
        msg = msg.slice(1);
        let r = msg.slice(0, 2);
        let g = msg.slice(2, 4);
        let b = msg.slice(4, 6);
        let a = msg.slice(6, 8);

        let rgb = [parseInt(r, 16)/255.0, parseInt(g, 16)/255.0, parseInt(b, 16)/255.0];
        if (a !== "") {
            rgb.push(parseInt(a, 16)/255.0);
        }
        return [rgb];
    };
};

export const colorFunctions = {
    hexToRGB
};
